export default "__VITE_ASSET__HBN8Bhz5__"